import React, { useState } from 'react'
import classNames from 'classnames'
import { getFieldError } from 'utils/form'
import { InputText } from 'primereact/inputtext'
import LabelUI from './LabelUI'

const InputTextUI = (props) => {
  const { label, input, error, meta, ...otherProps } = props
  const inputError = error || getFieldError(meta) || meta?.error
  const randomNumber = Math.random().toString()
  const [showPassword, setShowPassword] = useState(false)

  const isPassword = input?.type === 'password'

  return (
    <>
      {label && <LabelUI htmlFor={randomNumber} required={otherProps?.required}>{label}</LabelUI>}
      {isPassword ? (
        <div className="p-inputgroup">
          <InputText
            {...input}
            {...otherProps}
            type={showPassword ? 'text' : 'password'}
            className={classNames({ 'p-invalid': inputError })}
            id={randomNumber}
          />
          <span
            className="p-inputgroup-addon cursor-pointer"
            onClick={() => setShowPassword(prev => !prev)}
          >
            <i className={showPassword ? 'pi pi-eye' : 'pi pi-eye-slash'} />
          </span>
        </div>
      ) : (
        <InputText
          {...input}
          {...otherProps}
          className={classNames({ 'p-invalid': inputError })}
          id={randomNumber}
        />
      )}
      {inputError && (
        <small className="p-error block mt-2">{inputError}</small>
      )}
    </>
  )
}

export default InputTextUI
